import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { AuthSession } from '../domain/entities/AuthSession';
import { COOKIES_NAMES } from '../constants/constants';
import { BrowserStorage } from 'elc-universal-utils';
import { SignInApiSdk } from '../../api/SignInApiSdk';

export class AuthSessionRepository {
    private _authSession: AuthSession;
    private apiSdk: SignInApiSdk;

    constructor() {
        this._authSession = diContainer.get(serviceNames.authSession);
        this.apiSdk = diContainer.get(serviceNames.signInApiSdk);
    }

    public get authSession() {
        return this._authSession;
    }

    public get storedAuthSession() {
        return new AuthSession(this.tokenCookie, this.tokenTypeCookie, null);
    }

    private get tokenCookie() {
        return BrowserStorage.getCookie(COOKIES_NAMES.AUTH_TOKEN);
    }

    private get tokenTypeCookie() {
        return BrowserStorage.getCookie(COOKIES_NAMES.AUTH_TYPE);
    }

    public handleTokenStorage = async () => {
        const { token: authToken, tokenType, expiration } = this.authSession;
        // handle auth token cookie storage

        return new Promise(resolve => {
            if (!authToken) {
                BrowserStorage.eraseCookie(COOKIES_NAMES.AUTH_TOKEN);
                BrowserStorage.eraseCookie(COOKIES_NAMES.AUTH_TYPE);
            } else {
                const storedToken = BrowserStorage.getCookie(COOKIES_NAMES.AUTH_TOKEN);
                if (!storedToken || storedToken !== authToken) {
                    // update cookie if a new token is available
                    BrowserStorage.setCookie(
                        COOKIES_NAMES.AUTH_TOKEN,
                        authToken,
                        new Date(Date.now() + (expiration || 0) * 1000)
                    );
                    BrowserStorage.setCookie(
                        COOKIES_NAMES.AUTH_TYPE,
                        <string>tokenType,
                        new Date(Date.now() + (expiration || 0) * 1000)
                    );
                }
                // set api Authorization header
                this.apiSdk.setBearerToken(authToken);
            }

            resolve();
        });
    };

    public getGuestToken = async () => {
        return this.apiSdk.guestTokenRequest();
    };

    public signOut = async () => {
        try {
            await this.apiSdk.signOut({ token: this.authSession.token });
        } catch (error) {
            throw error;
        }
    };
}
